/* angular:styles/component:css;867ce565d0074a36950da084e774c39e88924dfb8da2718eab4e88da5c70516a;/src/src/app/shared/components/pick-date-time-range/pick-date-time-range.ts */
.time-display-item {
  border: 0.067em;
  border-radius: 1em;
  border-style: solid;
  text-align: center;
}
/*# sourceMappingURL=pick-date-time-range.css.map */
